<div class="row container-form-list">
    <div class="col-12">
        <div class="card">
            <div class="card-header">
                <h6 class="card-title">
                    Selecione os mercados vinculados a esta unidade de negócio
                </h6>
            </div>
            <div class="table-responsive">
                <table class="table table-striped table-hover table-bordered">
                    <thead>
                        <tr>
                            <th class="col-delete"></th>
                            <th class="col-mercado">Mercado</th>
                            <th class="col-situacao text-center">Situação</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let entity of entities; let i = index">
                            <td class="col-delete">
                                <a class="btn btn-link" (click)="delete(i)">
                                    <i class="far fa-trash-alt" aria-hidden="true"></i>
                                </a>
                            </td>
                            <td class="col-mercado">
                                <sgt-mercado-typeahead [(ngModel)]="entity.mercado" name="mercado_{{i}}" id="mercado_{{i}}"
                                    #mercado="ngModel" #mercadoTypeahead [ngControl]="mercado"
                                    [situacao]="mercadoSituacaoAtivo"
                                    [dropup]="i > 5"
                                    (entitySelected)="onChangeMercado(entity, $event)" (clearEntity)="onChangeMercado(entity, null)">
                                </sgt-mercado-typeahead>
                            </td>
                            <td class="col-situacao text-center">
                                <sgt-mercado-situacao-badge
                                    [situacao]="entity.mercado?.situacao">
                                </sgt-mercado-situacao-badge>
                            </td>
                        </tr>
                        <tr *ngIf="entities.length === 0" class="no-record">
                            <td class="text-center" colspan="4">
                                <i class='fas fa-info' aria-hidden='true'></i> Nenhum registro encontrado
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="card-footer">
                <button type="button" class="btn btn-primary btn-sm" (click)="insert()">
                    <i class="fas fa-plus" aria-hidden="true"></i> Adicionar Mercado
                </button>
            </div>
        </div>
    </div>
</div>
